import { CONCIERGE_BACKGROUND } from "./conciergeBackground";

if (typeof document !== "undefined") {
  const style = document.createElement("style");
  style.dataset.conciergeBackground = "personal-photo";
  style.textContent = `
    .proposal-atmosphere {
      position: relative;
      overflow: hidden;
      background-image:
        linear-gradient(90deg, rgba(250, 247, 240, 0.08), rgba(250, 247, 240, 0.26)),
        url("${CONCIERGE_BACKGROUND}") !important;
      background-size: cover !important;
      background-position: center 42% !important;
    }

    .proposal-atmosphere > * {
      display: none !important;
    }

    .proposal-atmosphere::after {
      content: "";
      position: absolute;
      inset: 0;
      background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(247,243,234,0.13));
      pointer-events: none;
    }

    @media (max-width: 640px) {
      .proposal-atmosphere {
        min-height: 230px !important;
        background-position: 58% 42% !important;
      }
    }
  `;
  document.head.appendChild(style);
}
